import { RentalManagerUserInfoV2WebApiHandler_get_queryOptions } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';
import { hasStrongAuth } from '@zg-rentals/auth-comet/strong';

// Switched back to RMA's /users/get instead of capps' /auth/getUser even though
// capps is the architecturally correct endpoint here. Two reasons:
//   1. ZRM step-up logic gates on signals that are only emitted from RMA today
//      (we can't tell landlord vs renter calls apart at the capps layer).
//   2. The "disable ZRM users inactive for 2+ years" rollout reads from RMA, so
//      apps that don't hit RMA's /users/get can't enforce the lockout.
// Revisit once step-up + inactivity checks live outside RMA.
// TODO: switch back to `CometUserAuthenticationWebHandler_getUser_queryOptions`
// from `@zg-rentals/ts-capps-client-react-query` once the above are resolved.
export const Auth = defineAuthProvider({
  queryOptions: () => RentalManagerUserInfoV2WebApiHandler_get_queryOptions({ pageWithSensitiveInformation: true }),

  isAuthorized: hasStrongAuth((user) => ({ ...user, isLoggedIn: user.loggedIn })),
});

export const { useAuth } = Auth;
